export default __webpack_public_path__ + "static/sticker-1-2abdf7307c1edcf4a0c631e0ca7acbed.png";